import React from 'react';
import { Box, Heading, Text, Stack, Divider, Link, Button } from '@chakra-ui/react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import blogs from './blogData'; // Importing the blogs data

export default function Blog() {
  const { blogId } = useParams(); // Getting the blog ID from the URL
  const selectedBlog = blogs.find((blog) => blog.id === blogId); // Find the blog with the matching ID

  return (
    <Box className="w-full max-w-4xl mx-auto" p={{ base: 4, md: 6 }} boxShadow="lg" rounded="lg" bg="white">
      {selectedBlog ? (
        <>
          {/* Display the selected blog if blogId matches */}
          <Heading as="h1" size={{ base: 'lg', md: 'xl' }} mb={6} color="teal.600" textAlign={{ base: 'center', md: 'left' }}>
            {selectedBlog.title}
          </Heading>
          <Stack spacing={{ base: 4, md: 6 }}>
            {/* Introduction */}
            <Text fontSize="md" color="gray.800">
              {selectedBlog.content.introduction}
            </Text>

            {/* Sections */}
            {selectedBlog.content.sections.map((section, index) => (
              <Box key={index}>
                <Heading as="h2" size="md" color="teal.600" mb={2}>
                  {section.heading}
                </Heading>
                <Text fontSize="md" color="gray.800">
                  {section.body}
                </Text>
              </Box>
            ))}

            {/* Conclusion */}
            <Text fontSize="md" color="gray.800">
              {selectedBlog.content.conclusion}
            </Text>
          </Stack>
        </>
      ) : (
        <>
          {/* If no blog is selected, show a list of all blogs */}
          <Heading as="h1" size={{ base: 'lg', md: 'xl' }} mb={6} color="teal.600" textAlign={{ base: 'center', md: 'left' }}>
            Cook Time Blog
          </Heading>
          <Stack spacing={6}>
            {blogs.map((blog) => (
              <Link as={RouterLink} to={`/blog/${blog.id}`} key={blog.id} _hover={{ textDecoration: 'none' }}>
                <Box p={4} border="1px" borderColor="gray.200" rounded="md" _hover={{ bg: 'gray.50' }}>
                  <Heading as="h3" size="md" color="teal.600">
                    {blog.title}
                  </Heading>
                  <Text fontSize="sm" color="gray.600" mt={2}>
                    {blog.content.introduction.substring(0, 100)}...
                  </Text>
                </Box>
              </Link>
            ))}
          </Stack>
        </>
      )}
      <Divider my={4} />
    </Box>
  );
}
